// @ts-nocheck
import React from 'react';
import { Link } from 'react-router-dom';
import { Seo } from '../seo/Seo.jsx';
import { ArrowIcon } from '../components/VisualIcon.jsx';
import { useI18n } from '../i18n/I18nContext.jsx';

const copyByLocale = {
  ru: { seo: 'Страница не найдена', description: 'Запрошенная страница не опубликована.', title: 'Страница не опубликована.', text: 'Материал отсутствует, скрыт или ещё не прошёл проверку.', home: 'На главную' },
  uz: { seo: 'Sahifa topilmadi', description: 'So‘ralgan sahifa e’lon qilinmagan.', title: 'Sahifa e’lon qilinmagan.', text: 'Material mavjud emas, yashirilgan yoki hali tekshiruvdan o‘tmagan.', home: 'Bosh sahifaga' },
  en: { seo: 'Page not found', description: 'The requested page has not been published.', title: 'This page is not published.', text: 'The material is missing, hidden or has not passed verification yet.', home: 'Go home' },
};

export function NotFoundPage() {
  const { locale } = useI18n();
  const copy = copyByLocale[locale] || copyByLocale.ru;
  return <main className="not-found"><Seo title={copy.seo} description={copy.description} noindex/><div className="shell"><span>404</span><h1>{copy.title}</h1><p>{copy.text}</p><Link className="button primary" to="/">{copy.home} <ArrowIcon/></Link></div></main>;
}
